import { IContaCilRegra } from '../../../../../hooks/useContaCilRegras';

// Cromatica deliberada: rosa = casca/autoria, indigo = POC/valor,
// ambar = gap/sem-POC, verde = sucesso/D, vermelho = C/excluir, azul = brand.
export const C = {
  rosa: '#EC4899',
  rosaHover: '#DB2777',
  rosaTint: '#FCE7F3',
  indigo: '#6366F1',
  indigoTint: 'rgba(99, 102, 241, 0.10)',
  ambar: '#F59E0B',
  ambarText: '#B45309',
  ambarTint: '#FEF3C7',
  verde: '#10B981',
  verdeText: '#059669',
  verdeTint: 'rgba(16, 185, 129, 0.12)',
  vermelho: '#EF4444',
  vermelhoText: '#DC2626',
  vermelhoTint: 'rgba(239, 68, 68, 0.12)',
  brand: '#1B88F5',
  texto: '#0F172A',
  muted: '#64748B',
  subtle: '#94A3B8',
  hairline: 'rgba(15, 23, 42, 0.06)',
  rowHover: 'rgba(27, 136, 245, 0.04)',
};

export const fmtValor = (v: number) =>
  v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtData = (iso: string) => {
  if (!iso) return '';
  const [a, m, d] = iso.split('-');
  return `${d}/${m}/${a}`;
};

export interface GrupoCategoria {
  categoria: string;
  regras: IContaCilRegra[];
  comPoc: number;
}

/** Agrupa regras por categoria (ordenado por volume de regras desc). */
export function agrupaPorCategoria(rules: IContaCilRegra[]): GrupoCategoria[] {
  const map = new Map<string, IContaCilRegra[]>();
  rules.forEach(r => {
    const c = r.categoria || 'Outros';
    if (!map.has(c)) map.set(c, []);
    map.get(c)!.push(r);
  });
  return Array.from(map.entries())
    .map(([categoria, regras]) => ({
      categoria,
      regras,
      comPoc: regras.filter(r => r.poc_codigo || (r.poc_search && r.poc_search.length)).length,
    }))
    .sort((a, b) => b.regras.length - a.regras.length || a.categoria.localeCompare(b.categoria));
}

/** Limpa o nucleo estavel de um historico pra virar keyword sugerida. */
export function trimKeywordNoise(historico: string): string {
  return historico
    .toLowerCase()
    .replace(/\d{2}\/\d{2}(\/\d{4})?/g, ' ')
    .replace(/\d{6,}/g, ' ')
    .replace(/[^a-zà-ú\s]/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .slice(0, 4)
    .join(' ');
}
